import React, { useState, useEffect } from "react";

const HistoryAuditForm = () => {
  const [modules, setModules] = useState([
    "Birth Certificate",
    "Death Certificate",
    "Marriage Certificate",
    "Local Certificate",
    "Domicile",
    "FIR & Challan",
    "General DSR",
    "Special DSR",
    "Fard",
    "Mutation",
    "Complaints Cell",
  ]);

  const [selectedModule, setSelectedModule] = useState("");
  const [counts, setCounts] = useState({
    edit: 0,
    save: 0,
    delete: 0,
    print: 0,
  });

  const [historyData, setHistoryData] = useState([]);

  // Fetch daily records
  useEffect(() => {
    fetch("https://yourbackend.com/get_audit.php")
      .then((res) => res.json())
      .then((data) => setHistoryData(data));
  }, []);

  // Handle input change
  const handleInputChange = (e) => {
    setCounts({ ...counts, [e.target.name]: parseInt(e.target.value) || 0 });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedModule) {
      alert("Please select a module.");
      return;
    }

    const payload = {
      module_name: selectedModule,
      ...counts,
    };

    // Send data to backend
    const response = await fetch("https://yourbackend.com/update_audit.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
      alert("History updated successfully!");
      setCounts({ edit: 0, save: 0, delete: 0, print: 0 });
    }
  };

  return (
    <div className="container">
      <h2>Daily History Audit</h2>
      <form onSubmit={handleSubmit}>
        <label>Module:</label>
        <select value={selectedModule} onChange={(e) => setSelectedModule(e.target.value)} required>
          <option value="">Select Module</option>
          {modules.map((mod, index) => (
            <option key={index} value={mod}>{mod}</option>
          ))}
        </select>

        <label>Edit Count:</label>
        <input type="number" name="edit" value={counts.edit} onChange={handleInputChange} />

        <label>Save Count:</label>
        <input type="number" name="save" value={counts.save} onChange={handleInputChange} />

        <label>Delete Count:</label>
        <input type="number" name="delete" value={counts.delete} onChange={handleInputChange} />

        <label>Print Count:</label>
        <input type="number" name="print" value={counts.print} onChange={handleInputChange} />

        <button type="submit">Update History</button>
      </form>

      <h3>Today's Records</h3>
      <table border="1">
        <thead>
          <tr>
            <th>Module</th>
            <th>Edit</th>
            <th>Save</th>
            <th>Delete</th>
            <th>Print</th>
          </tr>
        </thead>
        <tbody>
          {historyData.map((record, index) => (
            <tr key={index}>
              <td>{record.module_name}</td>
              <td>{record.edit_count}</td>
              <td>{record.save_count}</td>
              <td>{record.delete_count}</td>
              <td>{record.print_count}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default HistoryAuditForm;
